import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

interface Props {
  onConfirm: () => void
}

export const ConfirmCancelSubscriptionModal: BaseModalType<Props> = ({ onConfirm, close }) => {
  const { t } = useTranslation()

  return (
    <Modal>
      <Modal.Header>{t('Subscriptions.Cancel Order?')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>
          <p className='text'>{t('Subscriptions.Do you really like to cancel the order?')}</p>
        </Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>
          {t('Subscriptions.Keep Order')}
        </Modal.Footer.Secondary>
        <Modal.Footer.Primary
          onClick={() => {
            onConfirm()
            close()
          }}
        >
          {t('Subscriptions.Yes, cancel')}
        </Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
